export class HeightRangePair<T> {
  constructor(public low: T, public high: T) {
  }

  clone(): HeightRangePair<T> {
    return new HeightRangePair<T>(
      this.low,
      this.high
    );
  }
}
